var _path;
import * as React from "react";
function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.745 22.543a3.604 3.604 0 000-5.094L15.351 3.055a3.583 3.583 0 00-3.924-.776A3.6 3.6 0 009.2 5.607v28.788c0 1.45.878 2.767 2.227 3.329 1.35.562 2.89.247 3.925-.776l14.393-14.394v-.011z"
  })));
}
export default SvgCaretRight;